/**
 * 当前环境的站点 origin 与产品区的公开配置。
 *
 * Home 即宿主，不再需要 Web 时代的 `VITE_PUBLIC_HOME_URL`。
 * 构建期内联的 `NEXT_PUBLIC_*` 只在这里读取，业务代码不直接访问 `process.env`。
 */

const DEFAULT_SITE_ORIGIN = 'https://enter.converge.ai';

function readUrl(value: string | undefined): string | undefined {
    const trimmed = value?.trim();
    return trimmed ? trimmed.replace(/\/+$/, '') : undefined;
}

/** 生成分享链接、Public Site 地址时使用的站点 origin。 */
export function getSiteOrigin(): string {
    return readUrl(process.env.NEXT_PUBLIC_SITE_ORIGIN) ?? DEFAULT_SITE_ORIGIN;
}

/** 实时服务地址，用于 Agent Builder 的实时 URL。 */
export function getSocketProjectBaseUrl(): string | undefined {
    return readUrl(process.env.NEXT_PUBLIC_SOCKET_PROJECT_BASE_URL);
}

export function getEnterDataPanelBaseUrl(): string | undefined {
    return readUrl(process.env.NEXT_PUBLIC_ENTER_DATA_PANEL_BASE_URL);
}

export function getGithubAppInstallUrl(): string | undefined {
    return readUrl(process.env.NEXT_PUBLIC_GITHUB_APP_INSTALL_URL);
}

/** 构建期给定的后端泳道回退值；URL 参数与本地存储仍优先。 */
export function getFallbackBackendSwimLane(): string | undefined {
    return process.env.NEXT_PUBLIC_SWIM_LANE?.trim() || undefined;
}

/** 本地开发关闭泳道持久化，避免上次调试的泳道残留到下一次会话。 */
export function isPersistedSwimLaneDisabled(): boolean {
    return process.env.NEXT_PUBLIC_DISABLE_PERSISTED_SWIM_LANE === 'true';
}

/** 部署环境；本地开发与单测未设置时按 dev 处理。 */
export type DeployEnv = 'dev' | 'staging' | 'prod';

export function getDeployEnv(): DeployEnv {
    const value = process.env.NEXT_PUBLIC_DEPLOY_ENV?.trim();
    return value === 'prod' || value === 'staging' ? value : 'dev';
}

/** 构建版本（CI 注入的 git sha），用于诊断上报。 */
export function getAppVersion(): string | undefined {
    return process.env.NEXT_PUBLIC_APP_VERSION?.trim() || undefined;
}

/** 本地开发读取项目文件失败时回退到本地数据，只在 `next dev` 下生效。 */
export function isLocalProjectFilesFallbackEnabled(): boolean {
    return process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_LOCAL_PROJECT_FILES_FALLBACK === 'true';
}
